// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { MutualFundsQuoteModule } from './app.module';
bootstrapAppModule(MutualFundsQuoteModule);
